import { FC, PropsWithChildren, Suspense } from 'react';

import { Box, theme } from '@betterment/style-closet-react';

import OtherBank from './OtherBank';

import Ellipsis from '../../../Shared/components/Ellipsis';

export interface IconProps {
  size?: number | string;
}

export interface BankIconProps extends IconProps {
  label?: string;
}

const OtherBankIcon: FC<PropsWithChildren<BankIconProps>> = ({ size = 36, label }) => {
  const themeSize = typeof size === 'number' ? theme.space[size] : size;

  return (
    <Suspense fallback={<Ellipsis />}>
      <Box
        as="span"
        width={themeSize}
        minWidth={themeSize}
        maxWidth={themeSize}
        height={themeSize}
        role="img"
        aria-label={label}
      >
        <OtherBank size={themeSize} />
      </Box>
    </Suspense>
  );
};

export default OtherBankIcon;
